import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { MThumbnailCardComponent } from './thumbnail-card.component';

@NgModule({
  imports: [CommonModule, FormsModule, NzCheckboxModule, NzButtonModule, NzIconModule],
  exports: [MThumbnailCardComponent],
  declarations: [MThumbnailCardComponent]
})
export class MThumbnailCardModule {}
